import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Search, Plus, Edit, Trash2, ArrowRight, Zap, EyeOff, Eye, Copy } from "lucide-react";

export default function RoutesTab({ routes, routeSearch, setRouteSearch, deleteRoute, onAddRoute, onEditRoute, onToggleDisable, onCloneRoute }) {
  return (
    <div data-testid="routes-tab">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <h2 className="text-xl font-semibold text-white">Routes ({routes.length})</h2>
        <div className="flex items-center gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
            <Input placeholder="Search routes..." value={routeSearch} onChange={(e) => setRouteSearch(e.target.value)} className="input-dark pl-10 w-56" />
          </div>
          <Button onClick={onAddRoute} className="btn-gold" data-testid="add-route-btn"><Plus className="w-4 h-4 mr-2" /> Add Route</Button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="data-table" data-testid="routes-table">
          <thead><tr><th>Route</th><th>Category</th><th>Price</th><th>Distance</th><th>Duration</th><th>SEO</th><th>Actions</th></tr></thead>
          <tbody>
            {routes.map((r) => (
              <tr key={r.route_id} className={r.disabled ? "opacity-50" : ""}>
                <td>
                  <div className="text-white text-sm flex items-center gap-1 flex-wrap">
                    <span className={r.disabled ? "line-through" : ""}>{r.origin}</span>
                    <ArrowRight className="w-3 h-3 text-[#C5A059]" />
                    <span className={`font-medium ${r.disabled ? "line-through" : ""}`}>{r.destination}</span>
                    {r.disabled && (
                      <span
                        className="ml-2 text-[10px] bg-rose-500/15 text-rose-300 px-2 py-0.5 rounded-sm flex items-center gap-1"
                        title="This route is hidden from public listings and the homepage form"
                        data-testid={`route-disabled-badge-${r.route_id}`}
                      >
                        <EyeOff className="w-3 h-3" /> Disabled
                      </span>
                    )}
                    {r.immediate_confirmation && !r.disabled && (
                      <span
                        className="ml-2 text-[10px] bg-blue-500/15 text-blue-300 px-2 py-0.5 rounded-sm flex items-center gap-1"
                        title="Customer requests for this route auto-advance to Awaiting Payment"
                        data-testid={`route-immediate-badge-${r.route_id}`}
                      >
                        <Zap className="w-3 h-3" /> Immediate
                      </span>
                    )}
                  </div>
                  <div className="text-white/30 text-xs">/{r.slug}</div>
                </td>
                <td><span className="text-[10px] bg-[#C5A059]/10 text-[#C5A059] px-2 py-0.5 rounded uppercase">{r.category}</span></td>
                <td className="text-[#C5A059] font-mono font-semibold">{"\u20AC"}{r.base_price}</td>
                <td className="text-white/60 text-sm">{r.distance_km ? `${r.distance_km} km` : "-"}</td>
                <td className="text-white/60 text-sm">{r.duration_hours ? `${r.duration_hours}h` : "-"}</td>
                <td><span className={`text-[10px] px-2 py-0.5 rounded ${r.seo_priority === "Top" ? "bg-purple-500/20 text-purple-400" : r.seo_priority === "High" ? "bg-emerald-500/20 text-emerald-400" : "bg-amber-500/20 text-amber-400"}`}>{r.seo_priority}</span></td>
                <td>
                  <div className="flex items-center gap-2">
                    <button onClick={() => onEditRoute(r)} className="text-white/40 hover:text-[#C5A059]" title="Edit"><Edit className="w-4 h-4" /></button>
                    {onCloneRoute && (
                      <button
                        onClick={() => onCloneRoute(r)}
                        className="text-white/40 hover:text-blue-300"
                        title="Clone this route (saved as Disabled)"
                        data-testid={`clone-route-${r.route_id}`}
                      >
                        <Copy className="w-4 h-4" />
                      </button>
                    )}
                    {onToggleDisable && (
                      <button
                        onClick={() => onToggleDisable(r)}
                        className={`${r.disabled ? "text-emerald-400 hover:text-emerald-300" : "text-white/40 hover:text-rose-400"}`}
                        title={r.disabled ? "Enable route" : "Disable route"}
                        data-testid={`toggle-disable-${r.route_id}`}
                      >
                        {r.disabled ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                      </button>
                    )}
                    <button onClick={() => deleteRoute(r.route_id)} className="text-white/40 hover:text-red-400" title="Delete"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
